import { api } from "./client";

export interface SystemRecentKills {
  count: number;
  capped: boolean;
}

export function getSystemRecentKills(
  systemId: string,
): Promise<SystemRecentKills> {
  return api<SystemRecentKills>(`/systems/${systemId}/recent-kills`);
}
